module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/logo-small-98f0a434f380362f410ec2cd2d960f7d.png";